
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"data-name":"Vector Smart Object copy 3","width":"40","height":"40","xlink:href":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAABRElEQVRYhc3ZvWrDMBQF4JMSMnTpmDfK1AfqQ3Uq7RpCtpA90MfokHZo4RQlNnES/0i6Rz8XhLAszCchYdl3RvIFwArAM4Bv1BELAK8ADiC55jlc/UgShcuC5Ftj2qFB1YK8wpF8am/UgLzDufZuh5LIXtwtsBRyENcHzI0cxQ0BcyEncWPA1Egv3BQwFdIb5wNUI4NwvkAVMhgXArQio3ChwFhkNC4GGIo04WKBvkgzzgKcQkpwVuAQUoZTAG+RG5IfKpwK2CI3vMRegXPlQfQF8gfg2Ln+AfArebJglN0152Zuq3x3K3HtmpMeMNS4vo1jQqbASZGpcDJkSpwEmRpnRubAmZC5cNHInLgoZG5cMLIELghZCueNLInzQpbGTSJrwI0ia8ENIlERrhc5P/3qB5ZNKuJLcky3hUuFuJTIO4DPf22WEqx487KEAAAAAElFTkSuQmCC"}})])
          )
        }
      }
    